<div class="container">
  @if (loadingValue()) {
    <div class="loading-state">
      <div class="skeleton skeleton-meta"></div>
      <div class="grid">
        <div class="card vertical-card skeleton-card">
          <div class="skeleton skeleton-title small"></div>
          <div class="skeleton skeleton-title large"></div>
          <div class="skeleton skeleton-chart vertical"></div>
        </div>

        <div class="card horizontal-card skeleton-card">
          <div class="skeleton skeleton-title medium"></div>
          <div class="skeleton skeleton-legend"></div>
          <div class="skeleton skeleton-chart horizontal"></div>
        </div>
      </div>
    </div>
  } @else {
    @if (!semDados()) {
      <div class="head">
        <div class="meta-area">
          <div class="meta-row">
            <img class="meta-logo" src="assets/meta.svg" alt="Meta" />

            <button
              class="toggle"
              type="button"
              [class.on]="metaToggleValue()"
              (click)="toggleMeta.emit(!metaToggleValue())">
              <span class="dot"></span>
            </button>

            @if (metaToggleValue()) {
              <div class="legend">
                <span class="meta-legend-item">
                  <span class="meta-dot marketing"></span>
                  <span class="meta-text">Marketing</span>
                </span>

                <span class="meta-legend-item">
                  <span class="meta-dot utility"></span>
                  <span class="meta-text">Utilidade</span>
                </span>

                <span class="meta-legend-item">
                  <span class="meta-dot auth"></span>
                  <span class="meta-text">Autenticação</span>
                </span>
              </div>
            }
          </div>

          <div class="visao-title">Visão Geral Anual</div>
        </div>
      </div>

      <div class="grid">
        <div class="card vertical-card">
          <div class="card-title">
            <div class="t1">Total Geral Anual</div>
            <div class="t2">{{ formatUSD(totalAnualValue()) }}</div>
          </div>

          <app-chart-custos-vertical
            [meses]="mesesValue()"
            [metaToggle]="metaToggleValue()">
          </app-chart-custos-vertical>
        </div>

        <div class="card horizontal-card">
          <div class="h-title">Total Geral Anual por Setor</div>
          <div class="sector-legend">
            @for (s of setoresLegenda(); track s; let i = $index) {
              <div class="item">
                <span class="dot" [style.background]="getSetorColorByRank(i, setoresLegenda().length)"></span>
                <span class="name">{{ s }}</span>
              </div>
            }
          </div>

          <app-chart-custos-horizontal [meses]="mesesValue()"></app-chart-custos-horizontal>
        </div>
      </div>
    } @else {
      <div class="empty-state">
        <app-balao-aviso texto="Nenhuma informação encontrada para o período"></app-balao-aviso>
      </div>
    }
  }
</div>
